import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from './ConfirmModal';
import { useUser } from '../contexts/UserContext';
const LogoutButton = () => {
   const [showConfirm, setShowConfirm] = useState(false);
   const navigate = useNavigate();
   const { logout } = useUser(); // Usar la función logout del contexto
   const handleLogout = () => {
      setShowConfirm(true);
   };
   const handleLogoutConfirm = () => {
      // Llamar a la función logout del contexto
      logout();
      // Limpiar cualquier intervalo que hayamos creado
      if (window.kycCheckInterval) {
         clearInterval(window.kycCheckInterval);
         window.kycCheckInterval = null;
      }
      // Restablecer banderas globales
      window.initialKycValidatedCheck = false;
      window.lastValidationCheck = 0;
      localStorage.clear();
      // Redirigir al login
      navigate('/sign-in');
      setShowConfirm(false);
   };
   const handleCancel = () => {
      setShowConfirm(false);
   };
   return (
      <>
         <span onClick={handleLogout} style={{ cursor: 'pointer' }}>
            <img
               src={process.env.PUBLIC_URL + '/assets/img/icon_logout.svg'}
               data-lightmodeimg
               alt="Logout"
               border="0"
               className='d-none d-lg-block'
            />
            <span className="d-lg-none">Logout</span>
         </span>
         <ConfirmModal
            isOpen={showConfirm}
            onClose={handleCancel}
            onConfirm={handleLogoutConfirm}
            message="You are about to log out"
            confirmText="Continue"
         />
      </>
   );
};
export default LogoutButton;